var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14453 2H28.9982V23.8534",
    stroke: "#FF7F1F",
    strokeWidth: 2.52457
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.60938H25.3339V22.1639H18.3041C18.3041 22.1639 13.9781 27.9968 13.7077 28.2399C13.4373 28.4829 9.11131 22.1639 9.11131 22.1639H1V6.60938Z",
    stroke: "#FF7F1F",
    strokeWidth: 2.03818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3287 15.9915V20.588H14.8355V15.9915H16.7049L17.0939 13.878H14.8355V13.1302C14.8355 12.013 15.2742 11.5851 16.4066 11.5851C16.7589 11.5851 17.042 11.5937 17.2062 11.611V9.69416C16.8972 9.60988 16.1408 9.52344 15.7043 9.52344C13.3941 9.52344 12.3287 10.6148 12.3287 12.9682V13.878H10.9023V15.9915H12.3287Z",
    fill: "#FF7F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.89,
    height: 29.89,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.c5c16c2526be7f86ac7d63030096be79.svg";
export { ForwardRef as ReactComponent };